import { t } from "../i18n";
import { requireFullAccess } from "../billing/access";
/** Tarayıcı yazdırma diyaloğu ile PDF. Rapor CSS'i @page A4 kullanır. */
export const PRINT_TIP = "Yazdırma penceresinde: Hedef → \"PDF olarak kaydet\", Kenar boşlukları → \"Yok\", \"Arka plan grafikleri\" → açık.";
export function printReport(): void { if (requireFullAccess(t("Yazdırma"))) window.print(); }
